import { Location, SearchFilter } from '@rygen/rygen-ui/model';

export class LocationSearchCriteria extends SearchFilter<Location> {
  criteria: string = '';
  pageSize: number = 10;

  constructor(opts?: Partial<LocationSearchCriteria>) {
    super(opts);

    if (opts?.criteria != null) {
      this.criteria = opts.criteria;
    }
  }
}
